export const validateContactUsForm = (data) => {
  const errors = {};
  if (!data.contactName?.trim()) {
    errors.contactName = "Contact name is required.";
  }
  if (!data.contactNum?.trim()) {
    errors.contactNum = "Contact number is required.";
  }
  return errors;
};
